export class LoginDTO{
  usernameOrEmail: string;
  password: string;
}
